export const GREY_BELT_CATEGORIES = [
  "grey_belt_land_more_favourable",
  "grey_belt_land_average_favourability",
  "grey_belt_land_less_favourable",
];
